import { ReportsProvider, ReportsService } from "@sportal/api/reports";
import { HttpService } from "@sportal/api";

export const makeReportsService = (
  http: HttpService,
  config: any
): ReportsService =>
  new ReportsService(
    new ReportsProvider(http, config.backendUrl, config.reportingTimeoutMinutes)
  );
